module.exports = __webpack_public_path__ + "static/img/star5-grey.df5cef1d.png";